<div class="nav-scroller bg-white shadow-sm">
    <nav class="nav nav-underline">
        <a class="nav-link" [routerLink]="['/vss','organization', id, 'informations']" routerLinkActive="active">
            <fa-icon [icon]="icons['faInfo']"></fa-icon> {{'VSS.MENU.generalinformations' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/vss','organization', id, 'training-sessions']" routerLinkActive="active">
            <fa-icon [icon]="icons['faInfo']"></fa-icon> {{'VSS.MENU.trainingSessions' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/vss','organization', id, 'news']" routerLinkActive="active">
            <fa-icon [icon]="icons['faStream']"></fa-icon> {{'VSS.MENU.news' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/vss','organization', id,'push-notification']" routerLinkActive="active">
            <fa-icon [icon]="icons['faBell']"></fa-icon> Push Notification
        </a>
        <a class="nav-link" [routerLink]="['/vss','organization', id,'events']" routerLinkActive="active">
            <fa-icon [icon]="icons['faCalendarAlt']"></fa-icon> {{'VSS.MENU.events' | translate}}
        </a>
    </nav>
</div>